import { render, staticRenderFns } from "./template.vue?vue&type=template&id=e6915df8&scoped=true&"
import script from "@/Components/Global/LoginFooter/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/LoginFooter/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/LoginFooter/style.scss?vue&type=style&index=0&id=e6915df8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6915df8",
  null
  
)

export default component.exports